import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
import { LogoFull } from './Logo';
import { Mail, MapPin, MessageCircle } from 'lucide-react';
interface FooterProps {
  onNavigate?: (page: 'home' | 'fitur' | 'kontak') => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  const {
    t,
    lang
  } = useLanguage();
  const currentYear = new Date().getFullYear();
  const productLinks = [{
    label: lang === 'en' ? 'Features & Modules' : 'Fitur & Modul',
    action: () => onNavigate?.('fitur')
  }, {
    label: lang === 'en' ? 'Contact Sales' : 'Hubungi Sales',
    action: () => onNavigate?.('kontak')
  }];
  const sectionLinks = [{
    label: lang === 'en' ? 'Features' : 'Fitur',
    href: '#features'
  }, {
    label: lang === 'en' ? 'Solutions' : 'Solusi',
    href: '#solutions'
  }, {
    label: lang === 'en' ? 'Integrations' : 'Integrasi',
    href: '#technology'
  }, {
    label: lang === 'en' ? 'Business Impact' : 'Dampak Bisnis',
    href: '#impact'
  }, {
    label: lang === 'en' ? 'Contact' : 'Kontak',
    href: '#contact'
  }];
  return <footer className="bg-forest-50 py-16 relative" data-id="element-112">
      {/* Top Gradient Border */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-forest-200 to-transparent" data-id="element-113" />

      <div className="container mx-auto px-6 md:px-8" data-id="element-114">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-14" data-id="element-115">
          {/* Brand */}
          <div className="md:col-span-2" data-id="element-116">
            <div className="mb-3" data-id="element-117">
              <LogoFull size={36} data-id="element-118" />
            </div>
            <p className="text-xs text-forest-400 font-medium uppercase tracking-wide mb-4" data-id="element-119">
              PT NETKRIDA TUAH CAKRAWALA
            </p>
            <p className="text-sm text-forest-700 leading-relaxed max-w-xs mb-6" data-id="element-120">
              {t.footer.tagline}
            </p>
            {/* Contact Info */}
            <div className="space-y-2 text-sm text-forest-600" data-id="element-121">
              <a href="https://wa.me/628127634091" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-green transition-colors" data-id="element-122">
                <MessageCircle className="w-4 h-4 text-brand-green flex-shrink-0" data-id="element-123" />
                +62 812 7634 091
              </a>
              <a href="mailto:layanan@netkrida.co.id" className="flex items-center gap-2 hover:text-brand-green transition-colors" data-id="element-124">
                <Mail className="w-4 h-4 text-brand-green flex-shrink-0" data-id="element-125" />
                layanan@netkrida.co.id
              </a>
              <div className="flex items-start gap-2 text-forest-500" data-id="element-126">
                <MapPin className="w-4 h-4 text-brand-green flex-shrink-0 mt-0.5" data-id="element-127" />
                <span data-id="element-128">Pekanbaru, Riau 28282</span>
              </div>
            </div>
          </div>

          {/* Navigasi */}
          <div data-id="element-129">
            <h4 className="text-forest-900 font-semibold text-sm mb-5" data-id="element-130">
              {lang === 'en' ? 'Navigation' : 'Navigasi'}
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-131">
              {sectionLinks.map(link => <li key={link.label} data-id="element-132">
                  <a href={link.href} className="text-forest-600 hover:text-brand-green transition-colors" data-id="element-133">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Produk */}
          <div data-id="element-134">
            <h4 className="text-forest-900 font-semibold text-sm mb-5" data-id="element-135">
              {lang === 'en' ? 'Product' : 'Produk'}
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-136">
              {productLinks.map(link => <li key={link.label} data-id="element-137">
                  <button onClick={link.action} className="text-forest-600 hover:text-brand-green transition-colors text-left" data-id="element-138">
                    {link.label}
                  </button>
                </li>)}
            </ul>
            <div className="mt-6 flex items-center gap-2 text-xs text-forest-600 font-semibold" data-id="element-139">
              <span className="w-2 h-2 rounded-full bg-brand-gold animate-pulse" data-id="element-140" />
              {t.footer.operational}
            </div>
          </div>
        </div>

        <div className="border-t border-forest-100 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-141">
          <p className="text-sm text-forest-500" data-id="element-142">
            &copy; {currentYear} PT NETKRIDA TUAH CAKRAWALA. {t.footer.rights}
          </p>
          <span className="text-xs text-forest-400" data-id="element-143">
            <a href="https://www.netkrida.co.id" target="_blank" rel="noreferrer" className="hover:text-brand-green transition-colors" data-id="element-144">
              www.netkrida.co.id
            </a>
          </span>
        </div>
      </div>
    </footer>;
}